import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { ResponseDtoMapDeviationWorkflowListDeviationQuestionDto } from 'src/generated/services/TFinancialApi';
import { tFinancialService } from 'src/infra/services/tFinancialService';
import { cacheKeysUtil } from 'src/utils/cacheKeysUtil';

export const useQuestionnaire = (deviationId: string): UseQueryResult<ResponseDtoMapDeviationWorkflowListDeviationQuestionDto> =>
  useQuery(
    cacheKeysUtil.questionnaire(deviationId),
    async (): Promise<ResponseDtoMapDeviationWorkflowListDeviationQuestionDto> => (await tFinancialService.api.getQuestionnaire(deviationId)).data,
    {
      enabled: !!deviationId,
    }
  );

export type ChargeDomain =
  | 'HANDLING_CHARGE'
  | 'DOCUMENTATION'
  | 'CUSTOMS_CLEARANCE'
  | 'PICK_UP'
  | 'PICK_UP_AND_DROP_OFF'
  | 'THC'
  | 'PORT_CHARGES'
  | 'FREIGHT'
  | 'SEAL_FEE'
  | 'VGM_FEE'
  | 'DELIVERY'
  | 'CONTAINER_MAINTENANCE'
  | 'FUEL_SURCHARGE'
  | 'TOTAL_ORIGIN_CHARGES'
  | 'CONTAINER_CLEARANCE'
  | 'INSPECTION'
  | 'OVERTIME'
  | 'COLLECTION'
  | 'SPECIAL_HANDLING'
  | 'STORAGE'
  | 'SCREE'
  | 'DEFAULT_CHARGE_DOMAIN';
export type LegType = 'LEG_ONE' | 'LEG_TWO' | 'LEG_THREE' | 'HUB';
export const useCalculateSubCharge = (deviationId: string, legType: LegType, chargeDomain: ChargeDomain, isNrcf?: boolean) =>
  useQuery(
    cacheKeysUtil.calculateSubChargeDomain(deviationId, legType, chargeDomain),
    async () =>
      (
        await tFinancialService.api.calculateSubChargeDomain(deviationId, {
          'leg-type': legType,
          'charge-domain': chargeDomain,
        })
      ).data.data,
    {
      enabled: !!deviationId && !!chargeDomain && !!legType && !isNrcf,
    }
  );

// As 1 query
// export const useQuestionnaire = (invoiceId: string): UseQueryResult<UseQuestionnaireResponse> =>
// useQuery(
//   cacheKeysUtil.questionnaire(invoiceId),
//   async (): Promise<UseQuestionnaireResponse> => {
//     const [questionnaire, userResponse] = await Promise.all([
//       tFinancialService.api.getQuestionnaire(invoiceId),
//       tFinancialService.api.getUserResponse1(invoiceId),
//     ]);

//     return {
//       questions: questionnaire.data.data,
//       responses: userResponse.data.data,
//     };
//   },
//   {
//     enabled: !!invoiceId,
//   }
// );
